import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitControlCompleteModel } from '@apps-common/types/portal/unit-control'

const updateMyMonitoringControl = async (model: IUnitControlCompleteModel): Promise<IUnitControlCompleteModel> =>
  axios.post(`/my-monitoring/control/UpdateControl`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitControlCompleteModel
}

export const useMyMonitoringUpdateControl = (
  notify?: boolean,
  onSuccess?: (data: IUnitControlCompleteModel) => void,
  onError?: () => void
) =>
  useMutation({
    mutationKey: ['updateMyMonitoringControl'],
    mutationFn: ({ model }: Props) => updateMyMonitoringControl(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated control.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update control, please try again.')
      }
      if (onError) {
        onError()
      }
    },
    throwOnError: false
  })
